import React, { Component, useState,useEffect  } from 'react';
import cookie from 'react-cookies';


class SMAVoting extends Component {
	constructor(props){
		super(props);
		this.state = {
			alldata: null,
			showq: false,

		}
		this.getVotes = this.getVotes.bind(this);
		this.vote = this.vote.bind(this);
		this.vipvote = this.vipvote.bind(this);
		this.openvote = this.openvote.bind(this);

	}

	triggerEvent (SheVoteAction, SheVoteValue) {
		dataLayer.push({event: "she vote", virtualPageURL: "Beauty Award - "+this.state.alldata.name, SheVoteAction, SheVoteValue})
	}

	getVotes(vid){
		let that = this;
		var myHeaders = new Headers();
		myHeaders.append('pragma', 'no-cache');
		myHeaders.append('cache-control', 'no-cache');
		fetch('/wp-json/she-rest-api/getSMAVoteDetails/'+vid,{
			method:"GET",
			headers: myHeaders
		}).then(function(res){
			return res.json();
		})
		.then(function(response){
			that.setState({alldata: response});
			return response;
		}).catch(function(error){
			console.error(error);
		});
	}

	refresh(){
		let that = this;
		var myHeaders = new Headers();
		myHeaders.append('pragma', 'no-cache');
		myHeaders.append('cache-control', 'no-cache');
		fetch('/wp-json/she-rest-api/getSMAVoteDetails/'+this.props.vid,{
			method:"GET",
			headers: myHeaders
		}).then(function(res){
			return res.json();
		})
		.then(function(response){
				that.setState({alldata: response});
				that.forceUpdate()
				return response;
			}).catch(function(error){
				console.error(error);
		});
	}

	getButtonPath () {
		var time = this.state.alldata.end.replace(/-/g,':').replace(' ',':');
		time = time.split(':');
		var time1 = new Date(time[0],(time[1]-1),time[2],time[3],time[4],time[5]);
		if (  (+(time1)) - (+(new Date())) <= 0){
			return'/assets-2021/img/endvoting.png';
		}else{
			return  '/assets-2021/img/smavoting.png';
		}

	}

	vote(index, oindex,endday) {
		//if (this.state.alldata.phase === 'p1'||this.state.alldata.phase === 'p2'||this.state.alldata.phase === 'p3'||this.state.alldata.phase === 'p4') {
		//	//if (  (+(new Date('2021-11-05T03:59:59Z'))) - (+(new Date())) <= 0){
		//		alert('本輪投票活動已經結束，下一輪投票即將開始。')
		//		return;
		//	//}
		//}

		var time = endday.replace(/-/g,':').replace(' ',':');
		time = time.split(':');
		var time1 = new Date(time[0],(time[1]-1),time[2],time[3],time[4],time[5]);
		if (  (+(time1)) - (+(new Date())) <= 0){
			alert('本輪投票活動已經結束，下一輪投票即將開始。')
			return;
		}

		this.triggerEvent("Voting", index);
		let that = this;
		var time = parseInt(cookie.load(this.props.vid,true));
		if (isNaN(time)){
			time = 0;
		}
		if (time >= 1){
			alert('每一個項目只能投票1次')
			return ;
		}
		fetch('/wp-json/she-rest-api/sheSMAVote/'+this.props.vid+'/'+index,{
			method:"POST",
		})
		document.querySelector("#vote" + this.props.vid + "-" + index + " .voted").style.opacity = "1";
		document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "0%";
		//document.querySelector("#vote"+this.props.vid+"-"+index+" .vote-whole").style.top = "100%";
		var date = new Date();
		date.setTime(date.getTime()+(24*60*60*1000*365));
		cookie.save(this.props.vid, 1,{path:"/",expires:date});
		setTimeout(() => {
			document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.opacity = "0.3";
			document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "100%";
			//document.querySelector("#vote"+this.props.vid+"-"+index+" .vote-whole").style.top = "0%";
			this.refresh();
		}, 1400);

		setTimeout(
			() => {
				document.querySelector("#vote" + this.props.vid + "-" + index + " .voted").style.opacity = "1";
				//document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "100%";
			},2400);
	}
	vipvote(index, oindex,endday,code) {
		//if (this.state.alldata.phase === 'p1'||this.state.alldata.phase === 'p2'||this.state.alldata.phase === 'p3'||this.state.alldata.phase === 'p4') {
		//	//if (  (+(new Date('2021-11-05T03:59:59Z'))) - (+(new Date())) <= 0){
		//		alert('本輪投票活動已經結束，下一輪投票即將開始。')
		//		return;
		//	//}
		//}

		var time = endday.replace(/-/g,':').replace(' ',':');
		time = time.split(':');
		var time1 = new Date(time[0],(time[1]-1),time[2],time[3],time[4],time[5]);
		if (  (+(time1)) - (+(new Date())) <= 0){
			alert('本次投票活動已經結束。')
			return;
		}

		this.triggerEvent("VIP Voting", index);
		let that = this;
		var time = '';
		fetch('/wp-json/she-rest-api/sheSMAVVoteCheck/'+this.props.vid+'/'+code,{
			method:"POST",
		}).then(function(res){
			return res.json();
		}).then(function(response){
				console.log(response);
			console.log(typeof(response));
			console.log(response.message);
			console.log(typeof(response.message));
				if(response.message == 'true'){
					fetch('/wp-json/she-rest-api/sheSMAVVote/'+that.props.vid+'/'+index+'/'+code,{
						method:"POST",
					})
					document.querySelector("#vote" + that.props.vid + "-" + index + " .voted").style.opacity = "1";
					document.querySelector("#vote"+that.props.vid+"-"+index+" .voted").style.top = "0%";
					//document.querySelector("#vote"+this.props.vid+"-"+index+" .vote-whole").style.top = "100%";
					var date = new Date();
					date.setTime(date.getTime()+(24*60*60*1000*365));
					cookie.save(this.props.vid, 1,{path:"/",expires:date});
					setTimeout(() => {
						document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.opacity = "0.3";
						document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "100%";
						//document.querySelector("#vote"+this.props.vid+"-"+index+" .vote-whole").style.top = "0%";
						this.refresh();
					}, 1400);

					setTimeout(() => {
							document.querySelector("#vote" + this.props.vid + "-" + index + " .voted").style.opacity = "1";
							//document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "100%";
						},2400);
				}else{
					alert('每一個項目只能投票1次');
					return ;
				}
				return response;
			}).catch(function(error){
				console.error(error);
			});
		console.log(time);
		return;
		// if (time >= 1){
		// 	alert('每一個項目只能投票1次')
		// 	return ;
		// }

	}

	openvote(){
		this.triggerEvent("Open vote overlay", this.props.vid);
		this.setState({showq: true})
	 }

	 closevote(){
	 	this.setState({showq:false})
	 }

	//getButtonPath () {
		//	const {alldata} = this.state;
		//	/**
		//	 * In UNIX time
		//	 */
		//	const start = alldata.start_date ? (+(new Date(alldata.start_date))) : (+(new Date("1997-06-30T16:00:00Z")));
		//	const end = alldata.end_date ? (+(new Date(alldata.end_date))) : (+(new Date("2047-06-30T16:00:00Z")));
		//	const now = (+(new Date()));
		//	// Scenario 1 : The voting is ended
		//	if (now > end) { return '/assets-2021/img/endvoting.png'; }
		//	// Scenario 2 : On going
		//	if (now <= end && now > start) { return '/assets-2021/img/voting.png'; }
		//	// Scenario 3 : Not started
		//	if (now <= start) { return '/assets-2021/img/voting-not-started.png'; }

		//return '/assets-2021/img/voting.png';
	//}

	componentDidMount(){
		this.getVotes(this.props.vid);
	}


	render(){
		const {alldata, showq} = this.state;
		let {vid,role,code} = this.props;
		let that = this;

		// Show the loading icon.
		if (alldata === null) {
			return (
				<div className="bvote-block bvote-block--loading">
					<img src="/assets-2021/img/ba/2022/logo.png" />
				</div>
			);
		}

		const first = alldata.options.slice(0,3);
		let btnpath =this.getButtonPath();

		return(
			<div className="smavote-block">

				<div className="vote-out">
					<div className="votenow"><img  src={btnpath} onClick={that.openvote.bind(this)}/></div>
				<h2>{alldata.name}</h2>
					{/*<div className="vote-img" onClick={that.openvote.bind(this)}>*/}
					{/*	<img className="votenow-m" src={btnpath} onClick={that.openvote.bind(this)}/>*/}
					{/*	<img src={alldata.img} />*/}
					{/*</div>*/}
					<div className="vote-first" onClick={that.openvote.bind(this)}>
						{
							first?
							first.map(function(item, index) {
								let percentage = item.vote+'%';
								return (
									<div  className={"option option"+index} key={index}>
										<div className={"option-img option"+index} >
											<img src={item.img} />
										</div>
										<div className={"option-detail option"+index} >
												<div className="option-visual">
													<div className="vote-detail">
														<span className="brand">{item.brand}</span>
														<span className="ename">{item.e_name}</span>
														<span className="name">{item.name}</span>


													</div>
												</div>
										</div>
									</div>

								)
							}):''
						}
					</div>
					{showq?
						<div className="overlay-whole">
							<div className="overlay-bg" onClick={that.closevote.bind(this)}></div>

						<div className="overlay-vote">
							<div onClick={that.closevote.bind(this)} className="voteclose">
								<i className="icon-close-01"></i>

							</div>
							<div className="shelogo"></div>
							<div className="shepattern"></div>
							<div className="vote-top">
								<div className="title"><p>{alldata.name}</p></div>
							</div>
							<div className="vote-end">
								{/* NOTE : It's UTC time, which is same as 香港時間10月15日中午12時正 */}
							</div>
							<div className="whole-option">
								{
									alldata.options?
										alldata.options.map(function(item, index) {
											let percentage = item.vote+'%';
											let vindex = index +1;
											return (
												<div  className={"option option"+index} key={index}>
													<a href={item.link} target="_blank">
														<div className={"option-img option"+index} >
															<img src={item.img} />
															<img src="/assets-2021/img/ba/more.png" className="morelink"/>
														</div>
													</a>

													<div className={"option-detail option"+index} id={"vote"+vid+"-"+item.index}>
														<div className="voted" >
															<p>Thank You</p>
														</div>
														{
															role=='norm'?
																<div className="vote-whole" onClick={that.vote.bind(this,item.index, index, alldata.end)}>
																	<div className="option-visual">
																		<div className="vote-detail">
																			<span className="brand">{item.brand}</span>
																			<span className="ename">{item.e_name}</span>
																			<span className="name">{item.name}</span>
																			<span className="votebtn">按此投票</span>
																		</div>
																	</div>
																</div>:
																<div className="vote-whole" onClick={that.vipvote.bind(this,item.index, index, alldata.end, code)}>
																	<div className="option-visual">
																		<div className="vote-detail">
																			<span className="brand">{item.brand}</span>
																			<span className="ename">{item.e_name}</span>
																			<span className="name">{item.name}</span>

																			<span className="votebtn">按此投票</span>
																		</div>
																	</div>
																</div>
														}

													</div>
												</div>
											)
										}):''
								}

							</div>
							{/*<div className="othervote">*/}
							{/*	<div>*/}
							{/*		<span>想知邊個成員最有前妻緣? 邊個最多fans</span>*/}
							{/*		<img src="/assets-2021/img/othervote.png"/>*/}
							{/*	</div>*/}

							{/*</div>*/}


						</div>
						</div>
						:''

					}

				</div>
			</div>
		)
	}
}

export default SMAVoting



// WEBPACK FOOTER //
// ./src/SMAVoting.js